import { Flex, Stack, Text } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { ContinueMinStdReportButton } from '@/module/MinimalStandard/components/ContinueMinStdReportButton';
import { MinStdCriteriaOverview } from '@/module/MinimalStandard/components/MinStdCriteriaOverview';
import { MinStdIndicatorOverview } from '@/module/MinimalStandard/components/MinStdIndicatorOverview';
import { MinStdTotalOverview } from '@/module/MinimalStandard/components/MinStdTotalOverview';
import { getMinStdResultOptions } from '@/module/MinimalStandard/model/MinStdQuery';

import { Content } from '@/core/components';

import { JobTitle } from '@feature/utils';

interface AuthorEvaluationOverviewProps {
  userId: number;
  jobTitle: JobTitle | null;
  startYear: number;
  endYear: number;
}

export function AuthorMinStdOverview(props: AuthorEvaluationOverviewProps) {
  const { userId, jobTitle, startYear, endYear } = props;
  const { t } = useTranslation();
  const { data } = useSuspenseQuery(getMinStdResultOptions(userId, jobTitle, startYear, endYear));

  return (
    <Stack>
      <Content type="full">
        <Flex
          align="center"
          justify="space-between"
        >
          <Stack gap="4px">
            <Text>
              {data.user.lastName} {data.user.firstName}, {t(`jobTitleEnum.${data.jobTitle}`)}
            </Text>
            <Text c="dimmed">
              {startYear} - {endYear}
            </Text>
          </Stack>
          <ContinueMinStdReportButton />
        </Flex>
      </Content>
      <MinStdIndicatorOverview result={data.indicators} />
      <MinStdCriteriaOverview
        jobTitle={data.jobTitle}
        result={data.criteria}
      />
      <MinStdTotalOverview
        totalScore={data.totalScore}
        unfulfilledCriteria={data.unfulfilledCriteria}
      />
    </Stack>
  );
}
